<template>
    <div class="accesos">
        <h2 class="subheading grey--text">{{$t('mensaje_pase_salida')}}</h2>
        <v-container class="my-1">
            <v-card class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('mensaje_pase_salida')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-layout fill-height row wrap>
                        <v-flex xs6>
                            <v-card>
                                <v-card-text>
                                    <h3>{{$t('msg_people_inside_company')}}</h3>
                                    <v-flex>
                                        <v-menu
                                                v-model="calendario"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="computedInitialDateFormatted"
                                                        prepend-icon="event"
                                                        name="date"
                                                        :label="$t('Fecha_ini')"
                                                        :hint="$t('formato_fecha')"
                                                        persistent-hint
                                                        readonly
                                                        v-on="on"
                                                        :error-messages="errores.date"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    :locale="$t('region')"
                                                    v-model="date"
                                                    @input="calendario = false, split_date(date), get_access(yyyy, mm, dd)">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12>
                            <v-data-table
                                    v-model="selected"
                                    single-select="true"
                                    item-key="id"
                                    show-select
                                    :headers="headers"
                                    :loading="loading_data_access"
                                    :items="access"
                                    :rows-per-page-text="$t('filas_por_pagina')"
                                    :rows-per-page-items="[
                                                {text: '5', value: 5},
                                                {text: '10', value: 10},
                                                {text: '25', value: 25},
                                                {text: this.$t('todos'), value: -1}
                                            ]"
                                    class="elevation-1"
                                    :no-data-text="$t('no_registros_pase_salida')"
                            >
                                <template v-slot:items="props">
                                    <td>
                                        <v-btn
                                                v-if="props.item.exit_pass === false && props.item.datetime_checkout === null && props.item.status === 1 && props.item.access_qr_code === true && props.item.contractor === false"
                                                color="primary"
                                                block
                                                @click="signExitPassAccessCode(props.item.id)">
                                            {{$t('firmar')}}
                                        </v-btn>
                                        <v-btn
                                                v-if="props.item.exit_pass === false && props.item.datetime_checkout === null && props.item.status === 1 && props.item.access_qr_code === false && props.item.contractor === false"
                                                color="primary"
                                                block
                                                @click="signExitPassAccessNoCode(props.item.id)">
                                            {{$t('firmar')}}
                                        </v-btn>
                                        <v-btn
                                                v-if="props.item.exit_pass === false && props.item.datetime_checkout === null && props.item.status === 1 && props.item.access_qr_code === true && props.item.contractor === true"
                                                color="primary"
                                                block
                                                @click="signExitPassAccessContractor(props.item.id)">
                                            {{$t('firmar')}}
                                        </v-btn>
                                        <v-alert
                                                class="mr-2"
                                                v-show="props.item.exit_pass  === true"
                                                type="success">
                                            {{ $t('firmado')}}
                                        </v-alert>
                                        <v-alert
                                                class="mr-2"
                                                v-show="props.item.exit_pass === false && props.item.datetime_checkout != null"
                                                type="warning">
                                            {{ $t('no_firmado')}}
                                        </v-alert>
                                        <v-alert
                                                class="mr-2"
                                                v-show="props.item.status === 0"
                                                type="info">
                                            {{ $t('pending_authorization')}}
                                        </v-alert>
                                        <v-alert
                                                class="mr-2"
                                                v-show="props.item.status === 4"
                                                type="error">
                                            {{ $t('deny')}}
                                        </v-alert>
                                        <v-alert
                                            class="mr-2"
                                            v-show="props.item.status === 5"
                                            type="info">
                                          {{$t('waiting_room')}}
                                        </v-alert>
                                    </td>
                                    <td>{{ props.item.access_qr_code === true ? $t('acceso_con_codigo')  :  $t('acceso_sin_codigo') }}</td>
                                    <td>{{ props.item.guest_full_name }}</td>
                                    <td>{{ props.item.company_name }}</td>
                                    <td>{{ props.item.datetime_arrival }}</td>
                                    <td>{{ props.item.status === 5 ? $t('pendiente') : props.item.datetime_checkin}}</td>
                                    <td>{{ props.item.datetime_checkout == null ? $t('pendiente')  : props.item.datetime_checkout }}</td>
                                    <td>{{ props.item.host_full_name}}</td>
                                </template>
                                <template v-slot:rows-per-page-text="props">
                                    Hola
                                </template>
                                <template v-slot:pageText="props">
                                    {{props.rowsPerPage}}
                                    {{$t('Accesos')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import {mapState} from 'vuex'

    export default {
        name: "firma_salida",
        data: () => ({
            alerta: false,
            calendario: false,
            date: '',
            fecha_actual: '',
            errores: [],
            search: '',
            headers: [],
            access:[],
            loading_data_access: false,
            yyyy: '',
            mm: '',
            dd: '',
            selected: []
        }),
        created: function(){
            this.fecha_actual = this.get_current_date()
            this.date = this.fecha_actual
            this.get_access(this.yyyy, this.mm, this.dd)
        },
        beforeUpdate() {
            this.headers = [
                {
                    text: this.$t('firma_salida'),
                    align: 'center',
                    sortable: false,
                    value: 'exit_pass'
                },
                {
                    text: this.$t('type_of_access'),
                    align: 'left',
                    sortable: true,
                    value: 'access_qr_code'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'guest_full_name'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'company_name'
                },
                {
                    text: this.$t('hora_llegada'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_arrival'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_checkin'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_checkout'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'host_full_name'
                }
            ]
        },
        computed: {
            ...mapState(['language']),
            computedInitialDateFormatted () {
                return this.formatDate(this.date)
            },
        },
        methods:{
            split_date: function(date){
                var arr = date.split('-')

                this.yyyy = arr[0]
                this.mm = arr[1]
                this.dd = arr[2 ]
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            get_current_date: function (){
                var today = new Date();
                this.dd = today.getDate();
                this.mm = today.getMonth()+1;
                this.yyyy = today.getFullYear();

                if(this.dd<10)
                {
                    this.dd='0'+this.dd;
                }

                if(this.mm<10)
                {
                    this.mm='0' + this.mm;
                }
                today = this.yyyy + '-' + this.mm + '-' + this.dd;
                return today
            },
            get_access: function (yyyy, mm, dd) {
                this.loading_data_access = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/access/getAccsUnion/' + yyyy + '/'  + mm + '/' + dd + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if(response.data.length > 0)
                            this.access = response.data
                        else
                            this.access = []
                        console.log(this.access)
                        this.loading_data_access = false
                    })
                    .catch(error => {
                        this.loading_data_access = false
                        console.log(error)
                    })

            },
            signExitPassAccessCode (id) {
                console.log('Hola')
                const config = {
                    method: 'put',
                    url: 'https://empresa-service.intrare.app/empresas/access/update/exitpass/' + id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        pase_salida: true
                    }
                };
                axios(config)
                    .then(ok => {
                        this.get_access(this.yyyy, this.mm, this.dd)
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('mensaje_pase_salida_firmado'))
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            signExitPassAccessNoCode (pk) {
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/firmar_salida/' + pk + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.get_access(this.yyyy, this.mm, this.dd)
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('mensaje_pase_salida_firmado'))
                        console.log('FIRMADO')
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            signExitPassAccessContractor (pk) {
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/firmar_salida_access_contractor/' + pk + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.get_access(this.yyyy, this.mm, this.dd)
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('mensaje_pase_salida_firmado'))
                        console.log('FIRMADO')
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
        }
    }
</script>

<style scoped>

</style>
